import {Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges, ViewChild, ElementRef} from '@angular/core';
import {LotteriesService} from '../../lotteries.service';

@Component({
  selector: 'app-dw-select',
  templateUrl: './dw-select.component.html',
  styleUrls: ['./dw-select.component.scss']
})
export class DwSelectComponent implements OnInit, OnChanges {
  @Output() change: EventEmitter<any> = new EventEmitter<any>();
  @Output() display: EventEmitter<any> = new EventEmitter<any>();
  @Output() isOpen: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor(public lotteryService: LotteriesService) {
      this.isOpen.emit(false);
  }
    @Input() options: any;
    state: boolean;
    @Input() selected: any;
    @Input() value: any;
    @Input() displayer: any;
    @Input() image: boolean;
    @Input() animator: boolean;
    @Input() search: boolean;
    @Input() searchFromFirstLetter: boolean;
    @ViewChild('searchInput')
    searchElement: ElementRef;
    @ViewChild('selectList')
    selectList: ElementRef;
    looper: any;
    name: any;
    checkForValue: boolean;
    dontShow: boolean;
    timeout: any;
    oldKey: any;
    newKey: any;
    filtered: any;
    index: any;
  ngOnInit() {
    this.remakeSelect(!this.options[0]);
    this.timeout = null;
  }

  ngOnChanges(changes: SimpleChanges) {
      if (changes['options']) {
          this.remakeSelect(!changes['options'].currentValue[0]);
          this.checkForValue = false;
          if (this.selected && this.selected.selectDisplayName &&
              changes['options'].currentValue.some(e => e.selectDisplayName === this.selected.selectDisplayName)) {
          } else {
              this.selectOption(this.options[0]);
          }
      }
  }

    selectOption(val) {
        this.change.emit(val);
        this.selected = val;
        this.state = false;
        this.isOpen.emit(false);
    }

    remakeSelect(val) {
        if (val) {
            this.dontShow = true;
            this.display.emit(true);
        } else {
            this.dontShow = false;
            this.display.emit(false);
            this.state = false;
            this.isOpen.emit(false);
            this.looper = [];
            this.looper = [...this.options];
            this.selectOption(this.selected);
        }
    }
    onClickedOutside() {
        this.state = false;
        this.isOpen.emit(false);
        if (this.search) {
            this.searchElement.nativeElement.value = '';
        }
    }

    focusOn() {
      if (this.search) {
          if (this.state) {
              this.searchElement.nativeElement.focus();
          } else {
              this.searchElement.nativeElement.value = '';
          }
      }
    }

    makeSearch(e) {
    this.newKey = e.key;
    const optionHeight = this.selectList.nativeElement.children[0].offsetHeight;
        if (this.newKey === this.oldKey) {
            this.index += 1;
        } else {
            this.index = 0;
            this.filtered = this.options.filter((el) => {
                if (this.searchFromFirstLetter) {
                    return el.name.toLowerCase().startsWith(e.srcElement.value.toLowerCase());
                } else {
                    return el.name.toLowerCase().includes(e.srcElement.value.toLowerCase());
                }
            });
        }
        if (this.filtered[this.index] && this.filtered[this.index].name) {
            this.selectList.nativeElement.scrollTo({
                top:
                    this.options.findIndex(e => e.name === this.filtered[this.index].name) * optionHeight,
                behavior: 'smooth'
            });
        }
          clearTimeout(this.timeout);
          this.timeout = setTimeout(() => {
              e.srcElement.value = '';
              this.newKey = null;
          }, 3000);
        this.oldKey = this.newKey;
    }

    changeState() {
        this.state = !this.state;
        this.isOpen.emit(this.state);
    }
}
